import { useToast } from '@chakra-ui/react';
import { AxiosError, AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useRouter } from 'next/router';
import { useState } from 'react';
import * as Yup from 'yup';

import { saveCredentials } from '@helpers/credentials';
import { ISingleBaseResponse } from '@interfaces/IBaseResponse';
import { actionPostLogin } from '@libraries/api/login/login.function';
import { IParamLogin, IResponseLogin } from '@libraries/api/login/login.types';
import { showToast } from '@utils/constant';
import { useSetRecoilState } from 'recoil';
import { appMenu } from 'store/Common';

export const useAction = () => {
  const router = useRouter();
  const toast = useToast();
  const setMenu = useSetRecoilState(appMenu);

  const initialValues: IParamLogin = {
    email: '',
    password: '',
  };

  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const onShowPassword = () => setIsShowPassword(!isShowPassword);

  const returnUrl = router?.query?.returnUrl || '/';

  const { isLoading, mutate } = actionPostLogin();

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Email tidak valid!')
        .required('Email harus diisi!'),
      password: Yup.string().required('Password harus diisi'),
    }),
    onSubmit: (values: IParamLogin) => {
      mutate(values, {
        onSuccess: ({
          data: { data: resLogin },
        }: AxiosResponse<ISingleBaseResponse<IResponseLogin>>) => {
          saveCredentials(resLogin);
          setMenu(resLogin.menu_headers);
          let redirectUrl = returnUrl ? `${returnUrl}` : '/';
          router.push(redirectUrl);
        },
        onError: (err: AxiosError<ISingleBaseResponse<null>>) => {
          const { msg } = err.response.data;
          setError(msg.id);
          showToast({
            toast,
            title: 'Opps!',
            description: msg.id,
            status: 'error',
          });
        },
      });
    },
  });

  return {
    error,
    formik,
    isShowPassword,
    onShowPassword,
    isLoading,
  };
};
